module.exports = __webpack_public_path__ + "static/img/204.f6521cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/191025/204.jpg
// module id = MlGS
// module chunks = 0